import { doAjax } from './helper'
import { getInteriorImageForStoredComponent} from './imagesLogicController'
import { saveStateWithAjax, getPackageImageSource, checkKey, checkSubmit } from './screen-package-selection-global'




function checkSeatsAndSteeringWheelBadges_RS6RS7() {
	const imgSource = 'img/01_interieur/paketauswahl/au513_e-tron_gt_paketauswahl_rs_badges_zierleiste.png'
}

function addListeners_RS6RS7(frontCheckboxesMap, modalsCheckboxesMap) {	
	
	//Basisbild und Layer austauschen
	if ((frontCheckboxesMap['YVE_RS6RS7'].checked == false)) { 
		// Normalfall
		
		document.getElementById("front_background_image").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_startbild_r6_r7.png";
		
		//document.getElementById("YQN-img").src="img/06_paketauswahl/a8/paketauswahl/blank.png";
		var element =  document.getElementById('YQN-img');
		if (typeof(element) != 'undefined' && element != null) { // bild geladen?
			document.getElementById("YQN-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yqn_sitzblenden_in_leder.png";
		}

		//document.getElementById("YTA-img").src="img/06_paketauswahl/a8/paketauswahl/blank.png";
		var element =  document.getElementById('YTA-img');
		if (typeof(element) != 'undefined' && element != null) { // bild geladen?
			document.getElementById("YTA-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yta_dekoreinlagen_holz.png";
		}

		//document.getElementById("YUH-img").src="img/06_paketauswahl/a8/paketauswahl/blank.png";
		var element =  document.getElementById('YTA-img');
		if (typeof(element) != 'undefined' && element != null) { // bild geladen?
			document.getElementById("YUH-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yuh_airbag_kappe_in_leder.png";
		}

	} else if (frontCheckboxesMap['YVE_RS6RS7'].checked == true) {
		
		document.getElementById("front_background_image").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_sport-plus_wabe_q4q_yve_frt_basis.png";
		
		if ($('#YQN-img').length) {
			document.getElementById("YQN-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yqn_sitzblenden_in_leder_yve.png";
		}

		if ($('#YTA-img').length) {
			document.getElementById("YTA-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yta_dekoreinlagen_holz_yve.png";
		}

		if ($('#YUH-img').length) {
			document.getElementById("YUH-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yuh_airbag_kappe_in_leder_yve.png";
		}
	}



	
	
	frontCheckboxesMap['YTY'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTY', this.checked);

		if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
			frontCheckboxesMap['YVE_RS6RS7'].disabled = true
		}

		checkLocks_RS6RS7(frontCheckboxesMap)
		getPackageImages_RS6RS7('YTY', frontCheckboxesMap)
	})
	
	
	frontCheckboxesMap['YZ1'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YZ1',this.checked)

		if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
			frontCheckboxesMap['YVE_RS6RS7'].disabled = true
		}
		
		if (document.querySelector("input[name=modelcategory]").value != 'a6') {
			if (CarmodelPopUp == 14)  {
				if (this.checked) {
					const boxesToUncheck = ['3NT']
					boxesToUncheck.forEach(key => {
						frontCheckboxesMap[key].parentElement.classList.remove('is-checked')
						frontCheckboxesMap[key].checked = false
						saveStateWithAjax(key, false)
						getPackageImages_RS6RS7(key, frontCheckboxesMap)
					});

					/* Clean popup checkboxes */
					jQuery("#three_nt_popup_yes").removeClass("is-checked");
					jQuery("#three_nt_popup_no").removeClass("is-checked");
					jQuery("#three_nt_popup_yes .aui-checkbox__input").prop("disabled", false);
					jQuery("#three_nt_popup_no .aui-checkbox__input").prop("disabled", false);
					jQuery("#submit_button").prop("disabled", true);

					/* Clean popup checkboxes */

			
				} else {		
					frontCheckboxesMap['3NT'].parentElement.classList.remove('is-checked')
					frontCheckboxesMap['3NT'].checked = false
					
					checkLocks_RS6RS7(frontCheckboxesMap)
				}
			} else {
				if (this.checked) {
					//If we dont come from the modal
					if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
						frontCheckboxesMap['YVE_RS6RS7'].disabled = true
					}
				} else {
					checkLocks_RS6RS7(frontCheckboxesMap)
				}
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}

		//CheckModalVisibility
		var CarmodelPopUp = document.querySelector("input[name='carmodel']").value
		if (CarmodelPopUp == 14)  {
			const modal = document.querySelectorAll('.modal')[0]
			if (this.checked) {
				modal.classList.remove("hidden");
			} else {
				modal.classList.add("hidden")
			}
		}
		

		getPackageImages_RS6RS7('YZ1', frontCheckboxesMap)
	})

	frontCheckboxesMap['YQN'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YQN', this.checked)
		checkLocks_RS6RS7(frontCheckboxesMap)
		getPackageImages_RS6RS7('YQN', frontCheckboxesMap)
	})
	

	frontCheckboxesMap['YSJ_A6'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSJ_A6', this.checked)

		if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
			frontCheckboxesMap['YVE_RS6RS7'].disabled = true
		}

		checkLocks_RS6RS7(frontCheckboxesMap)
		getPackageImages_RS6RS7('YSJ_A6', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YVU'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVU', this.checked);	
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YVQ_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YVQ_RS6RS7'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YVE_RS6RS7'].disabled = true
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}
		getPackageImages_RS6RS7('YVU', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YVQ_RS6RS7'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVQ_RS6RS7', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YVU'].checked == false) { 
				frontCheckboxesMap['YVU'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YVE_RS6RS7'].disabled = true
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}
		getPackageImages_RS6RS7('YVQ_RS6RS7', frontCheckboxesMap)
	})
	
	frontCheckboxesMap['YUH'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YUH', this.checked);
		checkLocks_RS6RS7(frontCheckboxesMap)
		getPackageImages_RS6RS7('YUH', frontCheckboxesMap)
	})	
	
	frontCheckboxesMap['YTA'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTA', this.checked);
		checkLocks_RS6RS7(frontCheckboxesMap)
		getPackageImages_RS6RS7('YTA', frontCheckboxesMap)
	})		
	
	frontCheckboxesMap['YTO'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTO', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTQ_A6'].checked == false) { 
				frontCheckboxesMap['YTQ_A6'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YVE_RS6RS7'].disabled = true
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}
		getPackageImages_RS6RS7('YTO', frontCheckboxesMap)
	})

	frontCheckboxesMap['YTQ_A6'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTQ_A6', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTO'].checked == false) { 
				frontCheckboxesMap['YTO'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YVE_RS6RS7'].disabled = true
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}
		getPackageImages_RS6RS7('YTQ_A6', frontCheckboxesMap)
	})	
	
	frontCheckboxesMap['YSR_A6'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSR_A6', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YTU_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YTU_RS6RS7'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YVE_RS6RS7'].disabled = true
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}
		getPackageImages_RS6RS7('YSR_A6', frontCheckboxesMap)
	})	
	
	/*
	frontCheckboxesMap['YSQ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YSQ', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YSR_A6'].checked == false) { 
				frontCheckboxesMap['YSR_A6'].disabled = true
			}
			if (frontCheckboxesMap['YTU_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YTU_RS6RS7'].disabled = true
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}
		getPackageImages_RS6RS7('YSQ', frontCheckboxesMap)
	})
	*/	
	
	frontCheckboxesMap['YTU_RS6RS7'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YTU_RS6RS7', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YSR_A6'].checked == false) { 
				frontCheckboxesMap['YSR_A6'].disabled = true
			}
			if (frontCheckboxesMap['YVE_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YVE_RS6RS7'].disabled = true
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}
		getPackageImages_RS6RS7('YTU_RS6RS7', frontCheckboxesMap)
	})	


	/*
	frontCheckboxesMap['YVZ'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVZ', this.checked);
		checkLocks_RS6RS7(frontCheckboxesMap)
		//getImages_a6limousine('YVZ', frontCheckboxesMap)
		

		//CheckModalVisibility
		const modal = document.querySelectorAll('.modal')[0]
		if (this.checked) {
			modal.classList.remove("hidden")
		} else {
			modal.classList.add("hidden")
		}
		
	})
	*/

	
	frontCheckboxesMap['YVE_RS6RS7'].addEventListener('change', function () {
		checkSubmit(frontCheckboxesMap)
		saveStateWithAjax('YVE_RS6RS7', this.checked);
		if (this.checked) {
			//If we dont come from the modal
			if (frontCheckboxesMap['YZ1'].checked == false) { 
				frontCheckboxesMap['YZ1'].disabled = true
			}
			if (frontCheckboxesMap['YTY'].checked == false) { 
				frontCheckboxesMap['YTY'].disabled = true
			}
			if (frontCheckboxesMap['YSJ_A6'].checked == false) { 
				frontCheckboxesMap['YSJ_A6'].disabled = true
			}
			if (frontCheckboxesMap['YVU'].checked == false) { 
				frontCheckboxesMap['YVU'].disabled = true
			}
			if (frontCheckboxesMap['YVQ_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YVQ_RS6RS7'].disabled = true
			}
			if (frontCheckboxesMap['YTO'].checked == false) { 
				frontCheckboxesMap['YTO'].disabled = true
			}
			if (frontCheckboxesMap['YTQ_A6'].checked == false) { 
				frontCheckboxesMap['YTQ_A6'].disabled = true
			}
			if (frontCheckboxesMap['YSR_A6'].checked == false) { 
				frontCheckboxesMap['YSR_A6'].disabled = true
			}
			if (frontCheckboxesMap['YTU_RS6RS7'].checked == false) { 
				frontCheckboxesMap['YTU_RS6RS7'].disabled = true
			}
		} else {
			checkLocks_RS6RS7(frontCheckboxesMap)
		}
		getPackageImages_RS6RS7('YVE_RS6RS7', frontCheckboxesMap)


		//Basisbild und Layer austauschen
		if ((frontCheckboxesMap['YVE_RS6RS7'].checked == false)) { 
			// Normalfall
			
			document.getElementById("front_background_image").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_startbild_r6_r7.png";
			
			document.getElementById("YQN-img").src="img/06_paketauswahl/a8/paketauswahl/blank.png";
			var element =  document.getElementById('YQN-img');
			if (typeof(element) != 'undefined' && element != null) { // bild geladen?
				document.getElementById("YQN-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yqn_sitzblenden_in_leder.png";
			}

			document.getElementById("YTA-img").src="img/06_paketauswahl/a8/paketauswahl/blank.png";
			var element =  document.getElementById('YTA-img');
			if (typeof(element) != 'undefined' && element != null) { // bild geladen?
				document.getElementById("YTA-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yta_dekoreinlagen_holz.png";
			}

			document.getElementById("YUH-img").src="img/06_paketauswahl/a8/paketauswahl/blank.png";
			var element =  document.getElementById('YTA-img');
			if (typeof(element) != 'undefined' && element != null) { // bild geladen?
				document.getElementById("YUH-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yuh_airbag_kappe_in_leder.png";
			}

		} else if (frontCheckboxesMap['YVE_RS6RS7'].checked == true) {
			
			document.getElementById("front_background_image").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_sport-plus_wabe_q4q_yve_frt_basis.png";
			
			if ($('#YQN-img').length) {
				document.getElementById("YQN-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yqn_sitzblenden_in_leder_yve.png";
			}

			if ($('#YTA-img').length) {
				document.getElementById("YTA-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yta_dekoreinlagen_holz_yve.png";
			}

			if ($('#YUH-img').length) {
				document.getElementById("YUH-img").src="img/06_paketauswahl/a6a7/paketauswahl/au58x_paketauswahl_yuh_airbag_kappe_in_leder_yve.png";
				}
		}

	})
	

}

/**Controls frontcheckboxes disable */
function checkLocks_RS6RS7(frontCheckboxesMap) {
	//DEFINE UNLOCK CONDITIONS
	//const unlockConditionForYSI = !frontCheckboxesMap['YSJ_A6'].checked
	//const unlockConditionForYSJ_A6 = !frontCheckboxesMap['YSI'].checked
	//const unlockConditionForYVU = !frontCheckboxesMap['YUH'].checked
	//const unlockConditionForYUH = !frontCheckboxesMap['YVU'].checked	
	const unlockConditionForYTO = !frontCheckboxesMap['YTQ_A6'].checked && !frontCheckboxesMap['YVE_RS6RS7'].checked
	const unlockConditionForYTQ_A6 = !frontCheckboxesMap['YTO'].checked && !frontCheckboxesMap['YVE_RS6RS7'].checked
	const unlockConditionForYSR_A6 = !frontCheckboxesMap['YTU_RS6RS7'].checked && !frontCheckboxesMap['YVE_RS6RS7'].checked
	//const unlockConditionForYSQ = !frontCheckboxesMap['YSR_A6'].checked && !frontCheckboxesMap['YTU_RS6RS7'].checked
	const unlockConditionForYTU_RS6RS7 = !frontCheckboxesMap['YSR_A6'].checked && !frontCheckboxesMap['YVE_RS6RS7'].checked
	const unlockConditionForYVU = !frontCheckboxesMap['YVQ_RS6RS7'].checked && !frontCheckboxesMap['YVE_RS6RS7'].checked
	const unlockConditionForYVQ_RS6RS7 = !frontCheckboxesMap['YVU'].checked && !frontCheckboxesMap['YVE_RS6RS7'].checked

	
	const unlockConditionForYVE_RS6RS7 = 	!frontCheckboxesMap['YZ1'].checked && 	!frontCheckboxesMap['YTY'].checked && 	!frontCheckboxesMap['YSJ_A6'].checked && 	!frontCheckboxesMap['YVU'].checked && 	!frontCheckboxesMap['YVQ_RS6RS7'].checked &&	!frontCheckboxesMap['YTO'].checked && 	!frontCheckboxesMap['YTQ_A6'].checked && 	!frontCheckboxesMap['YSR_A6'].checked && 	!frontCheckboxesMap['YTU_RS6RS7'].checked

	const unlockConditionForYZ1 = !frontCheckboxesMap['YVE_RS6RS7'].checked
	const unlockConditionForYTY = !frontCheckboxesMap['YVE_RS6RS7'].checked
	const unlockConditionForYSJ_A6 = !frontCheckboxesMap['YVE_RS6RS7'].checked
	
	//const unlockConditionForYVZ = true

	
	//UPDATE VARS 
	//frontCheckboxesMap['YSI'].disabled = !unlockConditionForYSI
	//frontCheckboxesMap['YSJ_A6'].disabled = !unlockConditionForYSJ_A6
	//frontCheckboxesMap['YVU'].disabled = !unlockConditionForYVU
	//frontCheckboxesMap['YUH'].disabled = !unlockConditionForYUH
	
	frontCheckboxesMap['YTO'].disabled = !unlockConditionForYTO
	frontCheckboxesMap['YTQ_A6'].disabled = !unlockConditionForYTQ_A6
	frontCheckboxesMap['YSR_A6'].disabled = !unlockConditionForYSR_A6
	//frontCheckboxesMap['YSQ'].disabled = !unlockConditionForYSQ
	frontCheckboxesMap['YTU_RS6RS7'].disabled = !unlockConditionForYTU_RS6RS7
	//frontCheckboxesMap['YVZ'].disabled = !unlockConditionForYVZ

	frontCheckboxesMap['YVU'].disabled = !unlockConditionForYVU
	frontCheckboxesMap['YVQ_RS6RS7'].disabled = !unlockConditionForYVQ_RS6RS7

	frontCheckboxesMap['YVE_RS6RS7'].disabled = !unlockConditionForYVE_RS6RS7
	frontCheckboxesMap['YZ1'].disabled = !unlockConditionForYZ1
	frontCheckboxesMap['YTY'].disabled = !unlockConditionForYTY
	frontCheckboxesMap['YSJ_A6'].disabled = !unlockConditionForYSJ_A6

}


/**Gets images for all packages depending on selected packages */

function getImages_RS6RS7(frontCheckboxesMap) {
	for (const checkboxKey in frontCheckboxesMap) {
		//When screen loading
		/*
		const YRB_WAS_MODAL_SELECTED = frontCheckboxesMap['YVJ'].checked && frontCheckboxesMap['YSI'].checked
		const YVN_WAS_MODAL_SELECTED = frontCheckboxesMap['YVJ'].checked && frontCheckboxesMap['YSJ_A6'].checked
		*/
		/*
		if (YRB_WAS_MODAL_SELECTED || YVN_WAS_MODAL_SELECTED) {
			getPackageImages_RS6RS7(YRB_WAS_MODAL_SELECTED ? 'YSI-YVJ' : 'YSJ_A6-YVJ', frontCheckboxesMap)
		}else{
			getPackageImages_RS6RS7(checkboxKey, frontCheckboxesMap)
		}*/
		getPackageImages_RS6RS7(checkboxKey, frontCheckboxesMap)
	}
}

function getPackageImages_RS6RS7(packageCode, checkboxesMap) {
	let specialPackage = '';
	//When in modal
	if (packageCode == 'YSI-YVJ' || packageCode == 'YSJ_A6-YVJ'){
		specialPackage = packageCode
		packageCode = packageCode == 'YSI-YVJ' ? 'YSI' : 'YSJ_A6'
	}

	const checkboxElement = checkboxesMap[packageCode]
	const imageSource = specialPackage != '' ? getPackageImageSource(specialPackage) : getPackageImageSource(packageCode)
	let pressedPackageImg = document.getElementById(specialPackage != ''? specialPackage + '-img' : packageCode + '-img')
	const isChecked = checkboxElement.checked || checkboxElement.parentElement.classList.contains('is-checked')
	//if image does not exist we create it
	if (pressedPackageImg == null) {
		if (!isChecked ) return
		let imageArray = document.querySelector('.image-wrap')
		let newImage = document.createElement('IMG')
		newImage.classList.add('overlay')
		newImage.src = imageSource
		newImage.id = specialPackage != '' ? specialPackage + '-img' : packageCode + '-img'
		imageArray.insertAdjacentElement('beforeend', newImage)
	} else {
		pressedPackageImg.hidden = !isChecked
	}
	//change the steering wheel 
	//let hourMarkSteeringWheel = document.querySelector('#steering-wheel-overlay')
	//hourMarkSteeringWheel.src = checkboxesMap['YSJ_A6'].checked ? 'img/01_interieur/yrb-yvn_lenkrad/12-uhr-lenkrad_yvn_1xw-2pf/basislayer_alacantara_schwarz/au513_e-tron_gt_interior_lenkrad_yvn_1xw-2pf_basislayer.png' : ""
}


export { addListeners_RS6RS7, saveStateWithAjax, checkLocks_RS6RS7, getImages_RS6RS7, getPackageImages_RS6RS7, checkSeatsAndSteeringWheelBadges_RS6RS7}

